import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-doughnut-chart',
	templateUrl:'./DoughnutChartPluginCompPage.html',
	styles: [],
	styleUrls:['./DoughnutChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DoughnutChartPluginCompPage
{
	mdContent_908 = `\`\`\`java
import com.jwebmp.plugins.chartjs.DoughnutChart;
\`\`\``;
	mdContent_909 = `\`\`\`java
DoughnutChart(DoughnutData data)
\`\`\``;
	mdContent_910 = `\`\`\`java
DoughnutDataset dataset = new DoughnutDataset()
    .setData(40, 30, 20, 10)
    .addBackgroundColors(Color.RED, Color.GREEN, Color.BLUE, Color.YELLOW);
DoughnutData data = new DoughnutData()
    .addLabels("Q1", "Q2", "Q3", "Q4")
    .addDataset(dataset);
\`\`\``;
}
